'use strict';

function handleSortableClick(event) {
  const target = event.target.closest('.sortable');
  if (!target) return;
  document.location.search = target.dataset.order;
}

const init = () => {
  document.removeEventListener('click', handleSortableClick, true);
  document.addEventListener('click', handleSortableClick, true);
}

document.addEventListener('turbo:load', init, true);
document.addEventListener('DOMContentLoaded', init, true);
